import React, { ComponentType, FC } from "react";
import * as _ from "lodash";

import { Enterprise, useTranslation } from "@ctra/i18n";
import { CheckCircle, ClockCircleFilled, Smile } from "@ctra/components";
import { IdaQnAsEventStatus } from "@ctra/api";
import { classname } from "@ctra/utils";

import { useEvent, IdaQnAEvent } from "@events";

import styles from "./IdaQnAStatus.module.less";

/**
 * Ask Ida tracker status indicator
 * @param {boolean | undefined} expanded
 * @return {JSX.Element}
 * @constructor
 */
export const IdaQnAStatus: FC<{ expanded?: boolean }> = ({ expanded }) => {
  const { event, getContext } = useEvent<IdaQnAEvent>();
  const { t } = useTranslation();

  const { status: eventStatus } = getContext();

  const {
    events: {
      entity: { status }
    }
  } = Enterprise;

  /**
   * Map icons to the Ask Ida status
   */
  const statusToIconMap: Record<IdaQnAsEventStatus, ComponentType> = {
    [IdaQnAsEventStatus.analysing]: ClockCircleFilled,
    [IdaQnAsEventStatus.processing]: ClockCircleFilled,
    [IdaQnAsEventStatus.new]: ClockCircleFilled,
    [IdaQnAsEventStatus.completed]: CheckCircle,
    [IdaQnAsEventStatus.done]: CheckCircle,
    [IdaQnAsEventStatus.initial]: Smile
  };

  /**
   * Map styles to the Ask Ida status
   */
  const statusToStyleMap: Record<IdaQnAsEventStatus, string> = {
    [IdaQnAsEventStatus.analysing]: styles.Analysing,
    [IdaQnAsEventStatus.processing]: styles.Analysing,
    [IdaQnAsEventStatus.new]: styles.Analysing,
    [IdaQnAsEventStatus.completed]: styles.Completed,
    [IdaQnAsEventStatus.initial]: styles.Initial,
    [IdaQnAsEventStatus.done]: styles.Completed
  };

  const Icon = _.defaultTo(statusToIconMap[eventStatus], Smile);
  const statusStyle = _.defaultTo(statusToStyleMap[eventStatus], null);

  return (
    <div className={classname(styles.StatusBase, statusStyle)}>
      <Icon />
      {expanded && (
        <>
          &nbsp;
          {t<string>(status(event.source.type), {
            status: eventStatus
          })}
        </>
      )}
    </div>
  );
};
